import React from 'react'

import { useRouterScrollToTop } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'
import useIntercom from '@hooks/useIntercom'
import useServices from '@hooks/useServices'

interface AdminProps {
  children: React.ReactNode,
}

const Admin = (props: AdminProps) => {
  const { children } = props

  const { isBrandUser, isProviderUser } = useCurrentUser()

  const hideWidget = !(isBrandUser || isProviderUser)

  useIntercom({ hideWidget })

  useServices({ performHttpRequests: true })

  // Scroll Page to top when route changes
  useRouterScrollToTop()

  return children
}

export default Admin
